import styled from 'styled-components';
import GuestNavbar from './components/GuestNavbar';
import { GuestHeader } from './components/GuestHeader';
import Footer from '../../components/shared/footer/Footer';
import { GuestBenefits } from './components/GuestBenefits';
import { GuestContact } from './components/GuestContact';
import { GuestForm } from './components/GuestForm';
import { useParams } from 'react-router-dom';
import { useGuest } from './hooks/useGuest';
import { GuestTestimonyCarousel } from './components/GuestTestimonySlider';
import { useEffect } from 'react';

export const Guest = () => {
    const { id } = useParams();
    const { contact, loading, error, submitGuestInformation } = useGuest(id);

    return (
        <Page>
            <GuestNavbar />
            <GuestHeader />
            <ContentWrapper>
                <LeftColumn>
                    <GuestContact
                        contact={contact}
                        code={id}
                        loading={loading}
                        error={error}
                    />
                    <GuestBenefits />
                    <GuestTestimonyCarousel
                        autoPlayInterval={5000}
                        showDots={true}
                        pauseOnHover={true}
                        fadeDuration={500}
                    />
                </LeftColumn>
                <RightColumn>
                    <GuestForm
                        contact={contact}
                        submitGuestInformation={submitGuestInformation}
                        isContactLoading={loading}
                    />
                </RightColumn>
            </ContentWrapper>
            <Footer />
        </Page>
    );
};

const Page = styled.div`
    width: 100%;
    height: auto;
    background-color: #f9f9f9;
    overflow-x: hidden;
`;

const ContentWrapper = styled.div`
    display: flex;
    gap: 1rem;
    padding: 0.5rem 3rem;
    margin-bottom: 1rem;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 1024px) {
        flex-direction: column-reverse;
        padding: 1.5rem;
    }

    @media (max-width: 768px) {
        padding: 1rem;
        gap: 1.5rem;
    }
`;

const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex: 3;

    @media (max-width: 768px) {
        gap: 1.5rem;
    }
`;

const RightColumn = styled.div`
    flex: 2;
    display: flex;

    @media (max-width: 1024px) {
        width: 100%;
    }
`;
